import React from 'react';
import clsx from 'clsx';
import { BadgeLabel, BADGE_LABEL_COLORS, BADGE_LABEL_VARIANTS } from '@hevoio/hevo-ui-toolkit';
import type { BadgeLabelColorType } from '@hevoio/hevo-ui-toolkit';

interface OverlayBadgeProps {
  color?: BadgeLabelColorType ;
  content?: string | number;
  variant?: typeof BADGE_LABEL_VARIANTS.FLOAT | typeof BADGE_LABEL_VARIANTS.DOT;
  className?: string;
  direction?: { vertical: 'top' | 'bottom'; horizontal: 'left' | 'right' };
  children: React.ReactNode;
  badgeLabelClassName?: string;
}

export default function OverlayBadgeLabel({
  direction = { vertical: 'top', horizontal: 'right' },
  className = '',
  variant = BADGE_LABEL_VARIANTS.FLOAT,
  color = BADGE_LABEL_COLORS.FADED,
  content,
  badgeLabelClassName,
  children
}: OverlayBadgeProps) {
  let classNames = 'd-inline-block hd-label-overlay-container hd-label-overlay-label-overlap';
  classNames += ` hd-label-overlay-container-${direction.vertical}-${direction.horizontal}`;
  classNames += ` ${className}`;

  return (
    <div className={classNames} data-id='hd-label-overlay-container'>
      {children}
      {content ? (
        <BadgeLabel
          className={clsx('hd-label-overlay-label', badgeLabelClassName)}
          variant={variant}
          color={color}
        >
          {content}
        </BadgeLabel>
      ) : null}
    </div>
  );
}
